<template>
<div class="notice-wrap">
    <div class="notice" :class="{mb: mb}">
            {{ txt }}
    </div>
</div>
</template>
<script>

export default {
    name: 'noticewrap',
    props: {
        mb: { type: String, default: '' },
        txt: { type: String, default: '' }
    },
    data() {
        return {
        };
    },
    components: {
    },
    methods: {
    },

    beforeMount() {
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.notice-wrap {
    .notice {
        width:100%;
        // height:44px;
        font-size:15px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(23,23,23,1);
        line-height:22px;
        margin-bottom: 10px;
        &.mb {
            // height:rem(44);
            font-size:15px;
            line-height:rem(22);
            margin-bottom: rem(10);
            margin-top: rem(5);
        }
    }
}
</style>
